export default class AWSS3Manager {
  constructor(S3Client) {
    this.S3 = S3Client;
  }

  async GetS3Item(BucketName, Key) {
    // Define the parameters for invoking the Lambda function
    const params = {
      Bucket: BucketName, // The name of the S3 bucket
      Key: Key, // The key (path) of the object within the bucket
    };

    // Return a promise that resolves or rejects based on the Lambda invocation
    return new Promise(async (resolve, reject) => {
      await this.S3.getObject(params, function (err, data) {
        if (err) {
          console.error("Error invoking Lambda function:", err);
          reject(err); // Reject the promise with the error
        } else {
          resolve(data); // Resolve the promise with the parsed payload
        }
      });
    });
  }

  async UpdateS3Item(BucketName, Key, Body) {
    // Define the parameters for invoking the Lambda function
    const params = {
      Bucket: BucketName, // The name of the S3 bucket
      Key: Key, // The key (path) of the object within the bucket
      Body: Body,
    };

    // Return a promise that resolves or rejects based on the Lambda invocation
    return new Promise(async (resolve, reject) => {
      await this.S3.putObject(params, function (err, data) {
        if (err) {
          console.error("Error invoking Lambda function:", err);
          reject(err); // Reject the promise with the error
        } else {
          resolve(data); // Resolve the promise with the parsed payload
        }
      });
    });
  }
}
